export enum SortByDateTypes {
  LeastRecent = 'Least Recent',
  MostRecent = 'Most Recent',
}

export enum SortByTextTypes {
  AZ = 'A-Z',
  ZA = 'Z-A',
}

export enum SortByNumberTypes {
  ASC = 'Least',
  DESC = 'Most',
}

export enum FilterTypes {
  All = 'All',
  None = 'None',
  Dash = '-',
}

export enum SortByFilterType {
  All = 'All',
  AbsoluteReturn = 'Absolute Return',
  AssetWeighted = 'Asset Weighted',
  CompositeReturn = 'Composite Return',
  CompositeWeighted = 'Composite Weighted',
  PullForward = 'Pull Forward',
  StaticWeighted = 'Static Weighted',
}

export enum SortByCalculationFrequency {
  All = 'All',
  Day = 'Day',
  Month = 'Month',
  Quater = 'Quarter',
}

export const SortbyDateOptions = [
  {
    value: SortByDateTypes.LeastRecent,
    label: SortByDateTypes.LeastRecent,
  },
  {
    value: SortByDateTypes.MostRecent,
    label: SortByDateTypes.MostRecent,
  },
];

export const SortByTextOptions = [
  {
    value: SortByTextTypes.AZ,
    label: SortByTextTypes.AZ,
  },
  {
    value: SortByTextTypes.ZA,
    label: SortByTextTypes.ZA,
  },
];

export const SortByNumberOptions = [
  {
    value: SortByNumberTypes.ASC,
    label: SortByNumberTypes.ASC,
  },
  {
    value: SortByNumberTypes.DESC,
    label: SortByNumberTypes.DESC,
  },
];

export enum SortType {
  Date,
  Text,
  Number,
}

export const DefaultTableSort = {
  name: {
    value: SortByTextTypes.AZ,
    label: SortByTextTypes.AZ,
    type: SortType.Text,
  },
};

export enum FilterPlaceholders {
  AZ = 'A-Z',
  All = 'All',
  SortBy = 'Sort by',
}

export function resolveValue(obj: any, path: string) {
  const pathArray = path.split('.');
  var current = obj;
  while (path.length) {
    if (typeof current !== 'object') return current;
    current = current[pathArray.shift() ?? 0];
  }
  return current;
}

export const doSort = (data: Array<any>, key: string, value: any) => {
  switch (value.type) {
    case SortType.Text:
      return doSortByText(data, key, value);
    case SortType.Date:
      return doSortByDate(data, key, value);
    case SortType.Number:
      return doSortByNumber(data, key, value);
    default:
      return doSortByText(data, key, value);
  }
};

export const doSortByText = (data: Array<any>, key: string, value: any) => {
  const sortedData = [...data].sort((a: any, b: any) => {
    let nameA = resolveValue(a, key);
    let nameB = resolveValue(b, key);
    if (typeof nameA === 'string' || nameA instanceof String) {
      nameA = nameA.toLowerCase().trim();
      nameB = nameB.toLowerCase().trim();
    }

    if (nameA < nameB) {
      return value.label === SortByTextTypes.AZ ? -1 : 1;
    }

    if (nameA > nameB) {
      return value.label === SortByTextTypes.AZ ? 1 : -1;
    }

    return 0;
  });

  return sortedData;
};

export const doSortByNumber = (data: Array<any>, key: string, value: any) => {
  const sortedData = [...data].sort((a: any, b: any) => {
    let valueA = resolveValue(a, key);
    let valueB = resolveValue(b, key);

    if (value.label === SortByNumberTypes.ASC) {
      return valueA - valueB;
    } else {
      return valueB - valueA;
    }
  });

  return sortedData;
};

export const doSortByDate = (data: Array<any>, key: string, value: any) => {
  const sortedData = [...data].sort((a: any, b: any) => {
    let valA: string = resolveValue(a, key);
    let valB: string = resolveValue(b, key);
    let compareValue = 0;
    if (!valA && valB) compareValue = -1;
    if (valA && !valB) compareValue = 1;
    if (!valA && !valB) compareValue = 0;
    if (!valA || !valB) {
      if (value.label === SortByDateTypes.LeastRecent) {
        return compareValue;
      } else {
        return compareValue * -1;
      }
    } else {
      if (value.label === SortByDateTypes.LeastRecent) {
        return valA.localeCompare(valB);
      } else {
        return valB.localeCompare(valA);
      }
    }
  });

  return sortedData;
};

export const doFilterData = (data: Array<any>, filters: any) => {
  var filterKeys = Object.keys(filters);
  return data.filter(function (item) {
    return filterKeys.every(function (key) {
      const val =
        filters[key].value === FilterTypes.None
          ? FilterTypes.Dash
          : filters[key].value;
      if (val === null || val === undefined) {
        return true;
      }
      const resolvedValue: any = resolveValue(item, key);
      if (
        typeof resolvedValue === 'boolean' ||
        resolvedValue instanceof Boolean
      ) {
        return resolvedValue === val;
      }
      return resolvedValue.includes(val);
    });
  });
};
